export const getId = (item) => item.turbine_id;
